import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

/**
 * One QueryClient for the whole app, configured per CLAUDE.md's
 * "tenant is the unit of shared state" rule:
 *
 *  - staleTime: 0          → always treat tenant data as potentially stale
 *  - refetchOnMount        → re-query on view mount, so user B sees what
 *                            user A just changed
 *  - refetchOnWindowFocus  → off (too aggressive, causes surprise refetches)
 *  - retry: skip 401/403   → tokenManager already handles refresh; bouncing
 *                            on auth failures would loop
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60 * 1000,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
          return false
        }
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})

/** Build a tenant-scoped query key prefix. */
export function tenantKey(tenantId: string | null | undefined, ...parts: unknown[]) {
  return ['tenant', tenantId ?? 'unknown', ...parts] as const
}
